import React, { Children } from 'react';
import { ShieldCheck, Calendar, Star, MapPin, Search } from 'lucide-react';
import { motion } from 'framer-motion';
export function TrustBar() {
  const trustItems = [{
    icon: ShieldCheck,
    text: 'Licensed & Insured'
  }, {
    icon: Calendar,
    text: 'Since 2009'
  }, {
    icon: Star,
    text: '5-Star Rated'
  }, {
    icon: MapPin,
    text: 'St. Clair, Macomb & Oakland'
  }, {
    icon: Search,
    text: 'Free Roof Inspection'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="bg-brand-gray-dark py-6 relative z-30 border-t-4 border-brand-blue" data-id="element-454">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-455">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-4" data-id="element-456">
          {trustItems.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-center gap-2 text-white font-body text-sm md:text-base font-medium" data-id="element-457">
              <item.icon size={20} className="text-brand-blue shrink-0" data-id="element-458" />
              <span data-id="element-459">{item.text}</span>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}